module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-text-online_date.96ce002.png";